import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface WorkOrderFinishedMessageProps {
  onBackToList?: () => void;
}

/**
 * Mensaje de finalización cuando todas las líneas de trabajo están completadas
 */
export const WorkOrderFinishedMessage = ({ onBackToList }: WorkOrderFinishedMessageProps) => {
  const { t } = useTranslation('extraWorkOrdersModule');
  const navigate = useNavigate();

  const handleBackToList = () => {
    if (onBackToList) {
      onBackToList();
    } else {
      navigate('/extra-work-orders');
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center p-8">
      <div className="text-center max-w-md">
        <h3 className="text-success text-xl font-semibold mb-2">{t('detail.finished.title', 'Trabajo finalizado')}</h3>
        <p className="text-complementary-text mb-6">
          {t('detail.finished.message', {
            defaultValue: 'Todos los grupos de trabajo han sido completados',
          })}
        </p>
        <Button variant="primary" onClick={handleBackToList} data-testid="back-to-list-button" className="mx-auto">
          {t('detail.finished.back_button', 'Volver a la lista')}
        </Button>
      </div>
    </div>
  );
};
